/* Copyright (c) Trimble Inc. All rights reserved. */
import { SvgIcon, SvgIconProps, useTheme } from '@material-ui/core';
import React, { memo } from 'react';

export const IOTIcon: React.FC<SvgIconProps> = (props) => {
  const { palette } = useTheme();
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 43 33"
      fill="none"
    >
      <path d="M12.0137 20.6779L11.758 20.8152L11.7504 21.1053L11.4696 31.7726L10.5518 32.1398L0.5 26.4222V14.8504L10.7069 9.05734L20.9137 14.8504V15.9L12.0137 20.6779Z"  fill={palette.background.paper} stroke={palette.primary.dark}/>
      <path d="M31.0725 21.5207V21.2282L30.8176 21.0849L21.8125 16.0195V14.7703L32.0194 8.97726L42.2239 14.769L42.132 26.2556L32.1046 32.4192L31.0725 31.8386V21.5207Z"  fill={palette.background.paper} stroke={palette.primary.dark}/>
      <path d="M13.2227 6.75009V5.3044L21.4066 0.575882L29.7781 5.30756V6.74694L21.4066 11.3876L13.2227 6.75009Z" fill={palette.background.paper} stroke={palette.primary.dark}/>
    </SvgIcon>
  );
};

export default memo(IOTIcon);
